import { useStyles } from '@archipro-design/aria';
import * as S from '@modules/professional/component/page-layout/PageLayout.style';
import PageSections from '@modules/professional/component/page-layout/PageSections';

import PaginatedVideos from '@modules/professional/component/video-tab/PaginatedVideos';

import { useLoaderData, useSearchParams } from '@remix-run/react';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import type { VideoTileProp } from '@modules/professional/type';
import type { loader } from '@modules/professional/page/loaders/videos-page-loader.server';

const VideosPage = () => {
    const { css } = useStyles();
    const { companyVideosResult } = useLoaderData<typeof loader>();
    const [searchParams] = useSearchParams();
    const disableVideoPlayback = useIsDisabledInPreview('video_playback');

    const videos = (companyVideosResult?.videos as VideoTileProp[])?.map(
        (video) => ({
            ...video,
            disablePlay: disableVideoPlayback,
            shouldOpen: video.id === searchParams.get('video'),
        })
    );

    return (
        <div className={css(S.PageContent)}>
            <div className={css(S.Container)}>
                <PageSections>
                    {companyVideosResult && (
                        <PaginatedVideos
                            {...companyVideosResult}
                            videos={videos}
                        />
                    )}
                </PageSections>
            </div>
        </div>
    );
};

export default VideosPage;
